import React from 'react';
import PropTypes from 'prop-types';
import applySkeleton from '../../../hocs/applySkeleton';

const SubscriptionDetailHeader = ({ description = [], name, theme }) => (
    <>
        <p className={ theme.subscriptionHeader }>
            {name}
        </p>
        { !!description.length && (
            <div className={ theme.description }>
                {description.map(({ id, value, icon = null }) => (
                    <p key={ id === undefined ? value : id }>
                        {icon && <span className={ theme.descriptionIcon }>{icon}</span>}
                        {value}
                    </p>
                ))}
            </div>
        )}
    </>
);

SubscriptionDetailHeader.propTypes = {
    name: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    description: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        icon: PropTypes.node,
    })),
    theme: PropTypes.shape({}),
};

export default applySkeleton(SubscriptionDetailHeader);
